class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();

    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);


    this.sortSizeFilters = this.sortSizeFilters.bind(this);
    this.sortSizeFilters(); 

    this.sortPriceFilters(); 
    
    if (global.isAccessiBeEnabled) {
      const acsbFilterFunction = (mutation) => mutation.type === "attributes" 
        && mutation.target.classList.contains("acsb-contrast") 
        && mutation.target.classList.contains("facet-size");
      this.setAccessibeListeners({
        targetContainer: this,
        targetFilter: acsbFilterFunction,
        selectorQuery: ".size-list",
        selectorItemsQuery: "li span",
        toRemove: ["acsb-outline-contrast", "acsb-contrast"],
        toStyle: ""
      });
    }
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    }
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer){
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop){
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = element => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl) ?
        FacetFiltersForm.renderSectionFromCache(filterDataUrl, event) :
        FacetFiltersForm.renderSectionFromFetch(url, event);
 
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer').innerHTML;
    loadMoreProducts(true)
    const isMarketingTilesEnabled = document.getElementById('marketing-tiles')
    if (isMarketingTilesEnabled ) copyAndInjectTiles();
    totalTilesPerPage();
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
  }

  static renderFilters(html, event) {
   
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements =
      parsedHTML.querySelectorAll('#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter');
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    }
    const facetsToRender = Array.from(facetDetailsElements).filter(element => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));

  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];   
    activeFacetElementSelectors.forEach((selector) => {      
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
      document.querySelector(selector).closest('facet-filters-form').sortPriceFilters();
    })
    FacetFiltersForm.toggleActiveFacets(false);    
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents?.();
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    const targetElementAccessibility = target.querySelector('.facets__summary');
    const sourceElementAccessibility = source.querySelector('.facets__summary');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }

    if (targetElementAccessibility && sourceElementAccessibility) {
      target.querySelector('.facets__summary').outerHTML = source.querySelector('.facets__summary').outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      }
    ]
  }

  sortSizeFilters() {
    const order = [
      'ALL',
      'SHORT',
      'REGULAR',
      'TALL',
      'O/S',
      'PP',
      'PS',
      'PM',
      'PL',
      'XXS',
      '2XS',
      'XSS',
      'XS',
      'XS/S',
      'S',
      'SML',
      'SMALL',
      'S/M',
      'M',
      'MED',
      'MEDIUM',
      'MT',
      'M/L',
      'L',
      'LRG',
      'LARGE',
      'L/XL',
      'XL',
      'XLG',
      'X LARGE',
      'EXTRA LARGE',
      '1X',
      'XXL',
      'XXLRG',
      '2X',
      '2XL',
      '2XLRG',
      '3X',
      '3XLG',
      'XXXL',
      '3XL',
      'XXXXL',
      '4XL',
      '4XLRG',
      '5XL',
      '5XLG',
    ];

    const sizeFilters = this.querySelector('.size-list');
    if (!sizeFilters) {
      return;
    }
    const sizeElements = sizeFilters.querySelectorAll('li');
    const sizeArray = Array.prototype.slice.call(sizeElements, 0); // convert to array for sorting

    const parsePrefix = (val) => val.split(' ')[0];

    sizeArray.sort((a, b) => {
      const rawA = a?.querySelector('label input')?.getAttribute('value');
      const rawB = b?.querySelector('label input')?.getAttribute('value');
      const valueA = parsePrefix(rawA);
      const valueB = parsePrefix(rawB);
      if (order.indexOf(valueA) === -1) {
        return 1;
      } else if (order.indexOf(valueB) === -1) {
        return -1;
      }
      if (order.indexOf(valueA) === order.indexOf(valueB)) {
        return rawA > rawB ? 1 : -1;
      }
      return order.indexOf(valueA) - order.indexOf(valueB);
    });

    if (sizeFilters.classList.contains('mobile-facets__list')) {
      sizeFilters.replaceChildren(...sizeArray);
    } else {
      const updatedSizeArray = sizeArray.map((sizeLi, index) => {
        if (index < 10) {
          sizeLi.classList.remove('hidden');
          sizeLi.classList.remove('show-more-item');
        } else {
          sizeLi.classList.add('hidden');
          sizeLi.classList.add('show-more-item');
        }
        return sizeLi;
      })
      sizeFilters.replaceChildren(...updatedSizeArray);
    }
  }

  sortPriceFilters() {
     
    const filters = this.querySelector(`[data-filter="price"]`);
    if (!filters) {
      return;
    }
    
    const elements = [...filters.querySelectorAll('li')];
    const sorted = elements.sort((a, b) => {
      let aNum = this.getPriceValue(a);
      let bNum = this.getPriceValue(b);
      
      if (aNum < bNum){
        return -1;
      } else if (aNum > bNum){
        return 1;
      } else {
        return 0;
      }
    });

    filters.replaceChildren(...sorted);
  }

  getPriceValue(element){
    let value = element.querySelector('input').value
    value = value.replace(/[^[a-z0-9\s]/gi, '');
    const values = value.split(' ');
    const number = values.findLast(value => {
      return !isNaN(value);
    })
    
    return parseInt(number);
  }

  /**
   * Use this method to override AccessiBe inline styles and remove classes
   * @param {Object} params
   * @param {string|HTMLElement} params.targetContainer Element to attach the observables to. 
   * @param {function()} params.targetFilter Function that elements to consider when a change happens on targetContainer.
   * @param {string} params.selectorQuery Query to get parent element 
   * @param {string} params.selectorItemsQuery Query to find child elements from parent. 
   * @param {string[]} params.toRemove List of classes to remove from each element.
   * @param {string} params.toStyle String which will override or delete inline style from the element.
   * @returns {void}
   * 
   */
  setAccessibeListeners({targetContainer, targetFilter, selectorQuery, selectorItemsQuery, toRemove, toStyle = null}) {
    const config = { attributes: true, childList: true, subtree: true };
    const callback = (mutationList, observer) => {
      const isAccessiBeModifyingStyle = mutationList.filter(targetFilter).length;
      if (isAccessiBeModifyingStyle) {
        this.removeAccessiBeStyles({
          targetContainer,
          selectorQuery,
          selectorItemsQuery,
          toRemove,
          toStyle
        });
      }
    };
    const containerNode = typeof(targetContainer) == 'string' ? document.querySelector(targetContainer) : targetContainer;
    const observer = new MutationObserver(callback);
    observer.observe(containerNode, config);
  }

  removeAccessiBeStyles({targetContainer, selectorQuery,selectorItemsQuery, toRemove, toStyle}) {
    const container = targetContainer ? targetContainer: document.querySelector(selectorQuery);
    if (!container) {
      console.log('container not found by acsb-callback');
      return;
    }
    const elements = container.querySelectorAll(selectorItemsQuery);
    elements.forEach((e) => {
      toRemove.forEach((clsItem) => e.classList.remove(clsItem));
      e.style = toStyle;
      e.removeAttribute('data-acsb-clickable');
    });
  }
  
  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'))
      this.onSubmitForm(searchParams, event)
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            const noJsElements = document.querySelectorAll('.no-js-list');
            noJsElements.forEach((el) => el.remove());
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event)
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url = event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input')
      .forEach(element => element.addEventListener('change', this.onRangeChange.bind(this)));
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);
